/* MaritiemWinkel custom - announcement bar ticker */
(function(){
function init(){
var bar=document.querySelector('.AnnouncementBar');
if(!bar||bar.getAttribute('data-mw')==='1')return;
var slider=bar.querySelector('.AnnouncementBar__Slider');
if(!slider)return;
var txt=(slider.textContent||'').trim();
if(!txt)return;
bar.setAttribute('data-mw','1');
var wrap=bar.querySelector('.AnnouncementBar__Wrapper')||bar;
var m=document.createElement('div');
m.className='mw-marquee';
var t=document.createElement('div');
t.className='mw-marquee__track';
var half='';
for(var i=0;i<12;i++){half+='<span class="mw-marquee__item">'+txt+'</span>';}
t.innerHTML=half+half;
m.appendChild(t);
wrap.innerHTML='';
wrap.appendChild(m);
setTimeout(function(){
var h=bar.getBoundingClientRect().height;
document.documentElement.style.setProperty('--announcement-bar-height','0px');var sec=bar.closest('.shopify-section');if(sec){document.body.appendChild(sec);}
},60);
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
window.addEventListener('load',init); function mwFooter(){var lf=document.querySelector('#localization-footer');var b=document.querySelector('.site-footer__bottom_content .page-width');if(lf&&b&&!b.querySelector('.mw-lang')){var w=document.createElement('div');w.className='mw-lang';w.appendChild(lf);b.insertBefore(w,b.firstChild);}} if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',mwFooter);}else{mwFooter();} window.addEventListener('load',mwFooter);
})();
(function(){function mwDesc(){var d=document.querySelector('.product-single__description');if(!d||d.getAttribute('data-mwd')==='1')return;var g=document.querySelector('.grid.product-single');if(!g||!g.parentElement)return;d.setAttribute('data-mwd','1');var w=document.createElement('div');w.className='mw-product-desc';g.parentElement.insertBefore(w,g.nextSibling);w.appendChild(d);}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',mwDesc);}else{mwDesc();}window.addEventListener('load',mwDesc);})();


/* ---- Teklif formu: ornek metinler (mwQuotePlaceholders) ---- */
(function mwQuotePlaceholders(){
  var TXT = {
    nl: {
      'mw-field-1-block':'bv. UHMWPE 12-strengs',
      'mw-field-2-block':'bv. 14',
      'mw-field-3-block':'bv. 12',
      'mw-field-4-block':'bv. twee',
      'mw-field-5-block':'bv. ja',
      'mw-field-6-block':'bv. over het oog',
      'mw-field-7-block':'bv. zwart',
      'mw-field-8-block':'bv. 2',
      'ContactForm-message':'bv. landvast voor een zeilboot van 9 meter'
    },
    en: {
      'mw-field-1-block':'e.g. UHMWPE 12-strand',
      'mw-field-2-block':'e.g. 14',
      'mw-field-3-block':'e.g. 12',
      'mw-field-4-block':'e.g. two',
      'mw-field-5-block':'e.g. yes',
      'mw-field-6-block':'e.g. over the eye',
      'mw-field-7-block':'e.g. black',
      'mw-field-8-block':'e.g. 2',
      'ContactForm-message':'e.g. mooring line for a 9 metre sailing boat'
    },
    de: {
      'mw-field-1-block':'z. B. UHMWPE 12-litzig',
      'mw-field-2-block':'z. B. 14',
      'mw-field-3-block':'z. B. 12',
      'mw-field-4-block':'z. B. zwei',
      'mw-field-5-block':'z. B. ja',
      'mw-field-6-block':'z. B. über dem Auge',
      'mw-field-7-block':'z. B. schwarz',
      'mw-field-8-block':'z. B. 2',
      'ContactForm-message':'z. B. Festmacher für ein 9-Meter-Segelboot'
    }
  };
  function run(){
    if (!document.getElementById('mw-field-1-block')) return;
    var lang = (document.documentElement.getAttribute('lang') || 'nl').slice(0,2).toLowerCase();
    var map = TXT[lang] || TXT.nl;
    Object.keys(map).forEach(function(id){
      var el = document.getElementById(id);
      if (el && !el.getAttribute('placeholder')) el.setAttribute('placeholder', map[id]);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* ---- Footer: shop butonunu alt serite tasi (mwFooterShopFollow) ---- */
(function mwFooterShopFollow(){
  function run(){
    var btn = document.querySelector('.site-footer .follow-on-shop');
    var bar = document.querySelector('.site-footer .site-footer__bottom_content');
    if (!btn || !bar || btn.closest('.mw-shop-follow')) return;
    var loc = bar.querySelector('.site-footer__localization, [class*="localization"], form');
    var wrap = document.createElement('span');
    wrap.className = 'mw-shop-follow';
    wrap.appendChild(btn);
    if (loc && loc.parentNode) loc.parentNode.insertBefore(wrap, loc.nextSibling);
    else bar.insertBefore(wrap, bar.firstChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
})();
